// extracted by mini-css-extract-plugin
export default {"form":"GeracaoFaturamento_form__1TM27","areaBtn":"GeracaoFaturamento_areaBtn__h6Bgo","btn":"GeracaoFaturamento_btn__yy4fl","btn2":"GeracaoFaturamento_btn2__0sEDa"};